import '../plugins/StickyScrollBlockPlugin.js';
import '../plugins/ResponsiveHelper.js';

// initialize fixed blocks on scroll
export default function initStickyScrollBlock() {
	jQuery('.filters-wrap.filters-wrap--fair-navigation').stickyScrollBlock({
		setBoxHeight: true,
		activeClass: 'fixed-position',
		container: '.filters-section-inner',
		positionType: 'fixed',
		extraTop: function() {
			var totalHeight = 0;
			jQuery('#header').each(function() {
				totalHeight += jQuery(this).outerHeight();
			});
			return totalHeight;
		}
	});

	jQuery('.filters-wrap:not(.filters-wrap--fair-navigation)').stickyScrollBlock({
		setBoxHeight: true,
		activeClass: 'fixed-position',
		container: '.filters-section-inner',
		positionType: 'fixed',
		extraTop: function() {
			var totalHeight = 0;
			jQuery('#header').each(function() {
				totalHeight += jQuery(this).outerHeight();
			});
			jQuery('.filters-wrap--fair-navigation').each(function() {
				totalHeight += jQuery(this).outerHeight();
			});
			return totalHeight;
		}
	});
}
